/** @jsxImportSource @emotion/react */
import React, { useEffect } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
  Button,
  Text,
  Icon,
} from "@coreai/component-library";
import { css, useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  title: string;
  message: string;
}

export default function ConfirmModal(
  props: Readonly<ConfirmModalProps>
) {
  const { t } = useLanguage();
  const theme = useTheme();

  useEffect(() => {
    setTimeout(() => {
      localStorage.setItem("confirmBox", "close");
    }, 2000);
  }, []);

  const alertDialogBodyStyles: React.CSSProperties = {
    border: "none",
    padding: '24px',
    borderBottom: `1px solid ${theme.colors.strokeGray}`,
  };

  const bodyStyles: React.CSSProperties = {
    fontFamily: theme.typography.bodyMedium.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    fontWeight: theme.typography.bodyMedium.fontWeight,
    lineHeight: theme.typography.bodyMedium.lineHeight,
    color: theme.colors.textDark,
    marginBottom: theme.spacing.sm,
    paddingTop: 0,
    overflowY: "visible",
    gap: "1.5rem",
  };

  const closeBtnStyle = css`
      position: absolute;
      right: 24px;
      top: 26px;
      cursor: pointer;
    `;

  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(isOpen) => !isOpen && props.onClose()}
    >
      <AlertDialogContent size="sm">
        <AlertDialogHeader style={alertDialogBodyStyles}>
          <AlertDialogTitle>
            {props?.title}
          </AlertDialogTitle>
          <div css={closeBtnStyle}><Icon name="x-close" size="xs" onClick={() => props.onClose()}/></div>
        </AlertDialogHeader>

        <AlertDialogBody style={bodyStyles}>
          <Text style={bodyStyles}>
            {props?.message}
          </Text>
        </AlertDialogBody>

        <AlertDialogFooter style={alertDialogBodyStyles}>
          <AlertDialogCancel asChild>
            <Button variant="tertiary">{t("core_cancel")}</Button>
          </AlertDialogCancel>

          <AlertDialogAction asChild>
            <Button
              variant={"brand"}
              style={{ backgroundColor: theme.colors.primary }}
              onClick={() => props.onOk()}
            >
              {t("confirm_button")}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
